import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { withReflex, Flex } from 'reflexbox'
import { Element } from 'react-scroll'
import { nest } from 'recompose'
import T from 'i18n-react'
import { loading } from 'containers/Async/index'
import { POST_PID_SYNC } from './constants'

import Button from './Button'
import ProgressButton from './ProgressButton'
import RoleTable from 'containers/Admin/Product/ProductSelection/index'
import RoleDialog from 'containers/Admin/Product/ProductRole/index'
import Section from 'components/custom/Section/Section'

import styles from './styles.scss'

const ButtonContainer = ({ children }) => <Flex class={styles.buttonContainer} justify='flex-end'>{ children }</Flex>
const AsyncButton = loading(ProgressButton)(Button)([ POST_PID_SYNC ])
const ButtonSection = nest(Section, ButtonContainer, AsyncButton)

class MainPanel extends Component {
  render() {
    return (
      <Flex id='scrollContainer' column auto styleName='mainPanel'>
        <ButtonSection
          icon='refresh'
          label={T.translate('containers.admin.product.mainPanel.label')}
          onClick={this.props.onClick}
        />
        <Element name='Product Roles'>
          <RoleTable/>
          <RoleDialog/>
        </Element>
      </Flex>
    )
  }
}

export default CSSModules(MainPanel, styles)
